/**
 * @author       david.loehr@zumper.com (David Loehr)
 * @copyright    Copyright (c) 2024, Zumper
 * @description  detail mlsData reducer
 */

import { SerializableMap } from '@zcode/bizos'
import { falseReducer, payloadKeyReducer, trueReducer } from '@zcode/reducers'
import type { MlsModule, MlsWithMeta } from '@zcode/state-type'
import { combineReducers } from 'redux'
import { handleAction, handleActions } from 'redux-actions'
import {
  DONE_FETCHING_MLS_DATA,
  ERROR_FETCHING_MLS_DATA,
  RECEIVE_MLS_DATA,
  START_FETCHING_MLS_DATA,
} from '../constants'
import type { ActionTypes } from './types'

export const mlsModuleReducer = (state: MlsModule | undefined, action: ActionTypes) => {
  state = state ?? new SerializableMap()
  const { payload, type } = action
  switch (type) {
    case DONE_FETCHING_MLS_DATA:
    case ERROR_FETCHING_MLS_DATA:
    case START_FETCHING_MLS_DATA:
      return state.with(payload, mlsWithMetaReducer(state.get(payload), action))
    case RECEIVE_MLS_DATA:
      return state.with(payload.listingId, mlsWithMetaReducer(state.get(payload.listingId), action))
    default: {
      const unused = type satisfies never
    }
  }
  return state
}

export const mlsWithMetaReducer = combineReducers<MlsWithMeta, ActionTypes>({
  data: handleAction<MlsWithMeta['data'], ActionTypes, typeof RECEIVE_MLS_DATA>(
    RECEIVE_MLS_DATA,
    payloadKeyReducer('mlsData'),
    null
  ),
  error: handleActions<MlsWithMeta['error'], ActionTypes>(
    {
      [ERROR_FETCHING_MLS_DATA]: trueReducer,
      [RECEIVE_MLS_DATA]: falseReducer,
      [START_FETCHING_MLS_DATA]: falseReducer,
    },
    false
  ),
  fetching: handleActions<MlsWithMeta['fetching'], ActionTypes>(
    {
      [DONE_FETCHING_MLS_DATA]: falseReducer,
      [START_FETCHING_MLS_DATA]: trueReducer,
    },
    false
  ),
})
